import type { PhotoSetupStatus } from "./profilePhotoService";

type DeferredPhoto = { status: PhotoSetupStatus; reminderAfter: number };
const key = (uid: string) => `rauxa.profilePhoto.${uid}`;

export const profilePhotoPreferences = {
  read(uid: string): DeferredPhoto | null {
    try {
      const value = JSON.parse(localStorage.getItem(key(uid)) || "null");
      return value && ["skipped", "dismissed"].includes(value.status) && typeof value.reminderAfter === "number" ? value : null;
    } catch { return null; }
  },
  save(uid: string, value: DeferredPhoto) {
    try { localStorage.setItem(key(uid), JSON.stringify(value)); }
    catch { console.warn("Profile photo preference storage is unavailable."); }
  },
  clear(uid: string) {
    try { localStorage.removeItem(key(uid)); }
    catch { console.warn("Profile photo preference storage is unavailable."); }
  },
};
